module.exports = __webpack_public_path__ + "static/media/transfer_bnb.f73b7729.png";